import {
  set_text_field_focus,
  show_send_shoutout_modal,
  set_send_shoutout_modal_profile_user,
  show_send_shoutout_modal_with_user
} from '../actions/types';

const INITIAL_STATE = {
  isFocus: false,
  showSend: false,
  isUser: false,
  profileUser: null,
  showUser: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case set_text_field_focus:
      return { ...state, isFocus: action.payload };

    case show_send_shoutout_modal:
      return { ...state, showSend: action.payload, showUser: false };

    case set_send_shoutout_modal_profile_user:
      return { ...state, profileUser: action.payload };

    case show_send_shoutout_modal_with_user:
      return { ...state, showUser: action.payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/HotkeyReducer.js